<template>
  <scroll-list @refresh="onSearch" @loadpage="onSearch($event,1)" class="approval-list">
    <router-link
      class="weui-cell weui-cell_access"
      :class="{'weui-cell_has-hd': item.companyName}"
      v-for="item in items"
      :key="item.id"
      :to="'/process/instance/'+item.instanceId"
    >
      <div class="weui-cell__hd tag-warn" v-if="item.companyName">
        <p>{{item.companyName}}</p>
      </div>
      <div class="weui-cell__bd">
        <p>{{item.launcherName}}的{{item.ruleName}}</p>
        <p class="list-item-muted">{{item.launchTime}}</p>
        <template v-if="item.extraInfo">
          <p class="list-item-muted" v-for="(value, key) in JSON.parse(item.extraInfo)" :key="key">
            {{ key }}: {{ value }}
          </p>
        </template>
      </div>
      <div class="weui-cell__ft">
        <p>{{item.bizCode}}</p>
        <span
          class="list-item-status"
          :class="{'warning':item.status!=3}"
        >{{getOperationDesc(item)}}</span>
      </div>
    </router-link>
  </scroll-list>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    ScrollList
  },
  props: {
    items: Array,
    onSearch: Function
  },
  methods: {
    getOperationDesc(item) {
      var desc = "";
      if (item.status == 3) {
        if (item.operation) {
          return ["已同意", "已驳回", "已变更", "已读", "自动结束", "强制结束"][
            item.operation - 1
          ];
        } else {
          desc = "已审批";
        }
      } else {
        desc = item.ruleNodeType == 2 ? "待阅读" : "待审批";
      }
      return desc;
    }
  }
};
</script>
<style>
.approval-list {
  margin-bottom: 0;
}
.scroll-list.approval-list .weui-cells:before {
  display: inherit;
}
.approval-list .weui-cell.weui-cell_has-hd {
  padding-top: 35px;
}
.approval-list .weui-cell {
  align-items: baseline;
}
.approval-list .weui-cell .weui-cell__hd {
  position: absolute;
  top: 10px;
  left: 15px;
}
</style>